module.exports = __webpack_public_path__ + "static/img/zzc_1.404a056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche_Pro/zzc_1.png
// module id = 4PpF
// module chunks = 19